import TopNav from '@/pages/home/components/TopNav';
import Hero from '@/pages/home/components/Hero';
import ArchiveSection from '@/pages/home/components/ArchiveSection';
import TimelineSection from '@/pages/home/components/TimelineSection';
import ParseSection from '@/pages/home/components/ParseSection';
import DiscussSection from '@/pages/home/components/DiscussSection';
import RankSection from '@/pages/home/components/RankSection';
import SubscribeSection from '@/pages/home/components/SubscribeSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50">
      <TopNav />
      <main className="w-full">
        <Hero />
        <ArchiveSection />
        <TimelineSection />
        <ParseSection />
        <DiscussSection />
        <RankSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
    </div>
  );
}